export default __webpack_public_path__ + "static/media/ico_plus_gray.deb29cb4.svg";